import { render } from "./ProcessAsset.vue?vue&type=template&id=9a0b1518"
import script from "./ProcessAsset.vue?vue&type=script&lang=js"
export * from "./ProcessAsset.vue?vue&type=script&lang=js"

import exportComponent from "D:\\SVNwork\\01_工程区\\01_代码\\RPAPortal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__